export default "__VITE_ASSET__C_28JgTT__"